import React, { cloneElement, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { addDays, endOfMonth, format, startOfMonth } from 'date-fns';
import * as S from './styles';
import { FiArrowLeft, FiClipboard, FiMoon, FiSun } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import Header from '../../componentes/Header/index';
import Footer from '../../componentes/Footer/index';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { Context } from '../../services/contexts/StateContext';
import { SetFunctions } from '../../componentes/Functions';
import { Add_Arquivos } from '../../componentes/Cadastro/Add_Arquivos';

import EventColumn from './components/EventColumn';
import { getDiasAtraso, isEventoAtrasado } from './components/EventCard';
import PagEventoModal from '../../componentes/Modal/PagEventoModal';
import TarefasDia from './components/TarefasDia';
// -----------------------------

function diferencaEmDias(dataInicial, dataFinal) {
  if (!dataInicial || !dataFinal) return 0;

  const inicio = new Date(dataInicial);
  const fim = new Date(dataFinal);

  const diferencaMs = fim.getTime() - inicio.getTime();
  return Math.floor(diferencaMs / (1000 * 60 * 60 * 24));
}

// -----------------------------
function Preenchendo_Cards(evento) { 
  const dataEvento = evento?.dataEvento ? new Date(evento.dataEvento) : null;
  const dataPag = evento?.dataPag ? new Date(evento.dataPag) : null;
  const orcamento = Number(evento?.orcamento || 0);
  const pagamentos = Array.isArray(evento?.pagamentos) ? evento.pagamentos : [];
  const totalPago = pagamentos.length > 0
    ? pagamentos.reduce((total, pagamento) => total + Number(pagamento?.valor ?? pagamento?.valorPG ?? 0), 0)
    : Number(evento?.valorPag || 0);
  const pendente = Math.max(orcamento - totalPago, 0);
  const pagamentoParcialComHistorico = totalPago > 0 && pendente > 0;
  const hoje = new Date();

  const diasEvento = diferencaEmDias(dataEvento, hoje);
  const diasPagamento = diferencaEmDias(dataPag, hoje);

  if (evento?.dataPag) {
    return {
      id: evento?._id || evento?.id_Evento || evento?.codEvento || Math.random().toString(16).slice(2),
      placa: evento?.placa || 'EV-SEM-PLACA',
      modelo: evento.id_Veiculo?.modelo,
      financiamento: evento?.financiamento,
      parcelasPagas: Array.isArray(evento?.pagamentos) ? evento.pagamentos.length : undefined,
      arquivos: Array.isArray(evento?.arquivos) ? evento.arquivos : [],
      tarefas: Array.isArray(evento?.tarefas) ? evento.tarefas : [],
      tipo: evento?.tipoEvento || evento?.descricao || 'Evento sem descrição',
      cliente: evento?.id_Veiculo?.id_Cliente?.nome || evento?.nomeCliente || 'Cliente não informado',
      data: dataEvento ? format(dataEvento, 'dd/MM/yyyy') : 'Data não informada',
      diasEvento,
      status: pagamentoParcialComHistorico ? 'Liberado' : diasPagamento < 30 ? 'Pago' : 'Aberto',
      orcamento,
      pendente,
    };
  }

  let status = 'Aberto';

  if (diasEvento <= 14) {
    status = 'Aberto';
  } else if (diasEvento > 14) {
    status = 'Pendente';
  }

  if (pagamentoParcialComHistorico) {
    status = 'Liberado';
  }

  return {
    id: evento?._id || evento?.id_Evento || evento?.codEvento || Math.random().toString(16).slice(2),
    placa: evento?.placa || 'EV-SEM-PLACA',
    modelo: evento.id_Veiculo?.modelo,
    financiamento: evento?.financiamento,
    parcelasPagas: Array.isArray(evento?.pagamentos) ? evento.pagamentos.length : undefined,
    arquivos: Array.isArray(evento?.arquivos) ? evento.arquivos : [],
    tarefas: Array.isArray(evento?.tarefas) ? evento.tarefas : [],
    tipo: evento?.tipoEvento || evento?.descricao || 'Evento sem descrição',
    cliente: evento?.id_Veiculo?.id_Cliente?.nome || evento?.nomeCliente || 'Cliente não informado',
    data: dataEvento ? format(dataEvento, 'dd/MM/yyyy') : 'Data não informada',
    diasEvento,
    status,
    orcamento,
    pendente,
  };
}
// -----------------------------

const filtroPendentePadrao = '90+';
const PASSO_PISCADA = 0.50;
const DURACAO_PISCADA = 1.2;
const PAUSA_PISCADA = 600; // 600 = 10 minutos
const filtrosPendente = [
  { key: '90+', label: '+90' },
  { key: '60+', label: '+60' },
  { key: '30-60', label: '60-30'},
  { key: '0-30', label: '30-0'},
];

// Tipos de eventos -----------
const TIPOS_PERIFERICOS = ['Reparos_part', 'Retrovisor_part', 'Lanterna_part', 'Vidro_part'];
const TIPOS_COLISAO = ['Colisao_part'];
const TIPOS_ROUBO_PP = ['Roubo', 'Colisao_PT', 'Colisao_Incendio'];
const TIPOS_CARRO_RESERVA = ['C.Reserva'];

// -----------------------------
function getRangePendente(filtro) {
  const hoje = new Date();

  switch (filtro) {
    case '30-60':
      return {
        inicio: format(addDays(hoje, -60), 'yyyy-MM-dd'),
        fim: format(addDays(hoje, -30), 'yyyy-MM-dd'),
      };
    case '60+':
      return {
        inicio: format(addDays(hoje, -90), 'yyyy-MM-dd'),
        fim: format(addDays(hoje, -60), 'yyyy-MM-dd'),
      };
    case '90+':
      return {
        inicio: format(addDays(hoje, -999), 'yyyy-MM-dd'),
        fim: format(addDays(hoje, -91), 'yyyy-MM-dd'),
      };
    case '0-30':
    default:
      return {
        inicio: format(addDays(hoje, -30), 'yyyy-MM-dd'),
        fim: format(hoje, 'yyyy-MM-dd'),
      };
  }
};

// -----------------------------
export default function Dashboard() {
  const history = useHistory();
  const { state, dispatch } = useContext(Context);
  const { evento } = state.evento;
  const { listaPesquisa } = state.parametros;
  const { PesqTudoDataApagar, PesqIdEvento, BaixarEvento } = ApiEvento();
  const { SetEvento } = SetFunctions();
  const { SelectFile, AddArquivos } = Add_Arquivos();
  const [temaEscuro, setTemaEscuro] = useState(() => localStorage.getItem('dashboardTema') === 'escuro');
  const alternarTema = () => {
    setTemaEscuro((atual) => {
      localStorage.setItem('dashboardTema', atual ? 'claro' : 'escuro');
      return !atual;
    });
  };
  const [notasAbertas, setNotasAbertas] = useState(false);
  const [eventoTarefaInicial, setEventoTarefaInicial] = useState(null);
  const [eventosBrutos, setEventosBrutos] = useState({
    concluido: [],
    assistencia: [],
    perifericos: [],
    colisao: [],
    rouboPT: [],
    carroReserva: [],
  });

  const [eventos, setEventos] = useState({
    concluido: [],
    assistencia: [],
    perifericos: [],
    colisao: [],
    rouboPT: [],
    carroReserva: [],
  });

  const [assistenciaFiltro, setAssistenciaFiltro] = useState(filtroPendentePadrao);
  const [perifericosFiltro, setPerifericosFiltro] = useState(filtroPendentePadrao);
  const [colisaoFiltro, setColisaoFiltro] = useState(filtroPendentePadrao);
  const [rouboPTFiltro, setRouboPTFiltro] = useState(filtroPendentePadrao);
  const [carroReservaFiltro, setCarroReservaFiltro] = useState(filtroPendentePadrao);
  const [modalPagAberto, setModalPagAberto] = useState(false);
  const [piscarLiberado, setPiscarLiberado] = useState(false);
  const [colunaPagamento, setColunaPagamento] = useState(null);
  const pagamentoConfirmadoRef = useRef(null);

  const voltar = () => {
    dispatch({
      type: 'set_ListaPesquisa',
      payload: { ...listaPesquisa, listaEvento: [] },
    });
    history.push('/');
  };

  const [faixasDesabilitadas, setFaixasDesabilitadas] = useState({
    assistencia: [],
    perifericos: [],
    colisao: [],
    rouboPT: [],
    carroReserva: [],
  });
  // --------------------------------

  const registrarFaixasDesabilitadas = (coluna, faixas) => {
    if (!faixas.length) return;

    setFaixasDesabilitadas((prev) => ({
      ...prev,
      [coluna]: [...new Set([...prev[coluna], ...faixas])],
    }));
  };
  // --------------------------------

  const pesquisarPendente = async (filtro, filtros = {}, automatico = false) => {
    const faixas = automatico ? ['90+', '60+', '30-60', '0-30'] : [filtro];
    const faixasVazias = [];

    for (const faixa of faixas) {
      const { inicio, fim } = getRangePendente(faixa);
      const dados = await PesqTudoDataApagar(
        inicio,
        fim,
        true,
        false,
        false,
        false,
        'CADASTRO',
        null,
        filtros
      );

      if (Array.isArray(dados) && dados.length > 0) {
        return { dados, faixa, faixasVazias };
      }

      faixasVazias.push(faixa);
    }

    return { dados: [], faixa: filtro, faixasVazias };
  };

  // ------------------------------
  const carregarConcluido = async () => {
    const hoje = new Date();
    const inicioMes = startOfMonth(hoje);
    const fimMes = endOfMonth(hoje);

    const dados = await PesqTudoDataApagar(
      format(inicioMes, 'yyyy-MM-dd'),
      format(fimMes, 'yyyy-MM-dd'),
      true, false, false, false, 'PAGAMENTO'
    );
    const lista = (Array.isArray(dados) ? dados : []).filter((evento) => evento?.dataPag);

    const noMes = (data) => {
      if (!data) return false;
      const d = new Date(data);
      return d >= inicioMes && d <= fimMes;
    };

    const filtrados = lista
      .map((evento) => {
        const pagamentos = Array.isArray(evento?.pagamentos) ? evento.pagamentos : [];
        const valorPago = pagamentos.length > 0
          ? pagamentos
            .filter((pag) => noMes(pag?.data || pag?.dataPG))
            .reduce((total, pag) => total + Number(pag?.valor ?? pag?.valorPG ?? 0), 0)
          : Number(evento?.valorPag || 0);

        return {
          ...Preenchendo_Cards(evento),
          valorPago,
          data: format(new Date(evento.dataPag), 'dd/MM/yyyy'),
          dataPagamento: new Date(evento.dataPag).getTime(),
        };
      })
      .sort((a, b) => b.dataPagamento - a.dataPagamento);

    setEventos((prev) => ({ ...prev, concluido: filtrados }));
    setEventosBrutos((prev) => ({ ...prev, concluido: lista }));
  };

  // -------------------------------
  const carregarAssistencia = async (filtro = filtroPendentePadrao, automatico = false) => {
    setAssistenciaFiltro(filtro);

    const resultado = await pesquisarPendente(filtro, {
      excluirTipos: [
        'Colisao_part',
        'Roubo',
        'Colisao_PT',
        'Colisao_Incendio',
        ...TIPOS_PERIFERICOS,
        ...TIPOS_CARRO_RESERVA,
      ],
    }, automatico);
    setAssistenciaFiltro(resultado.faixa);
    registrarFaixasDesabilitadas('assistencia', resultado.faixasVazias);

    const lista = Array.isArray(resultado.dados) ? resultado.dados : [];

    const filtrados = lista
      .map(Preenchendo_Cards)
      .sort((a, b) => (b.diasEvento ?? 0) - (a.diasEvento ?? 0));
    setEventos((prev) => ({ ...prev, assistencia: filtrados }));
    setEventosBrutos((prev) => ({ ...prev, assistencia: lista }));
  };
  // -----------------------------

  const carregarPerifericos = async (filtro = filtroPendentePadrao, automatico = false) => {
    setPerifericosFiltro(filtro);

    const resultado = await pesquisarPendente(filtro, {
      tipos: TIPOS_PERIFERICOS,
    }, automatico);
    setPerifericosFiltro(resultado.faixa);
    registrarFaixasDesabilitadas('perifericos', resultado.faixasVazias);
    
    const lista = Array.isArray(resultado.dados) ? resultado.dados : [];

    const filtrados = lista
      .map(Preenchendo_Cards)
      .sort((a, b) => (b.diasEvento ?? 0) - (a.diasEvento ?? 0));
    setEventos((prev) => ({ ...prev, perifericos: filtrados }));
    setEventosBrutos((prev) => ({ ...prev, perifericos: lista }));
  };
  // -----------------------------

  const carregarColisao = async (filtro = filtroPendentePadrao, automatico = false) => {
    setColisaoFiltro(filtro);

    const resultado = await pesquisarPendente(filtro, {tipos: TIPOS_COLISAO,}, automatico);

    setColisaoFiltro(resultado.faixa);
    registrarFaixasDesabilitadas('colisao', resultado.faixasVazias);
    
    const lista = Array.isArray(resultado.dados) ? resultado.dados : [];
    
    const filtrados = lista
      .map(Preenchendo_Cards)
      .sort((a, b) => (b.diasEvento ?? 0) - (a.diasEvento ?? 0));
    setEventos((prev) => ({ ...prev, colisao: filtrados }));
    setEventosBrutos((prev) => ({ ...prev, colisao: lista }));
  };
  // -----------------------------

  const buscarFinanciamento = async () => {
    const resultados = await Promise.all(filtrosPendente.map(async ({ key }) => {
      const resultado = await pesquisarPendente(key, { tipos: ['Financiamento'] });
      const dados = (Array.isArray(resultado.dados) ? resultado.dados : [])
        .filter((evento) => evento?.tipoEvento === 'Financiamento');

      return { faixa: key, dados };
    }));
    const eventosVistos = new Set();
    const dados = resultados.flatMap((resultado) => resultado.dados).filter((evento) => {
      const id = evento?._id || evento?.id_Evento || evento?.codEvento;
      if (!id) return true;
      if (eventosVistos.has(id)) return false;
      eventosVistos.add(id);
      return true;
    });

    return {
      dados,
      faixasComDados: resultados
        .filter((resultado) => resultado.dados.length > 0)
        .map((resultado) => resultado.faixa),
    };
  };
  // -----------------------------

  const carregarRouboPP = async (filtro = filtroPendentePadrao, automatico = false) => {
    setRouboPTFiltro(filtro);

    const faixas = automatico ? ['90+', '60+', '30-60', '0-30'] : [filtro];
    const faixasVazias = [];
    let resultado = { dados: [], faixa: filtro };
    const financiamentos = await buscarFinanciamento();

    for (const faixa of faixas) {
      const resultadoRoubo = await pesquisarPendente(faixa, { tipos: TIPOS_ROUBO_PP });
      const dadosRoubo = Array.isArray(resultadoRoubo.dados) ? resultadoRoubo.dados : [];
      const temFinanciamentoNaFaixa = financiamentos.faixasComDados.includes(faixa);

      if (dadosRoubo.length > 0 || temFinanciamentoNaFaixa) {
        resultado = { dados: dadosRoubo, faixa };
        break;
      }

      faixasVazias.push(faixa);
    }

    setRouboPTFiltro(resultado.faixa);
    registrarFaixasDesabilitadas('rouboPT', faixasVazias);

    const lista = [
      ...(Array.isArray(resultado.dados) ? resultado.dados : []),
      ...(Array.isArray(financiamentos.dados) ? financiamentos.dados : []),
    ];

    const filtrados = lista
      .map(Preenchendo_Cards)
      .sort((a, b) => (b.diasEvento ?? 0) - (a.diasEvento ?? 0));
    setEventos((prev) => ({ ...prev, rouboPT: filtrados }));
    setEventosBrutos((prev) => ({ ...prev, rouboPT: lista }));
  };
  
  // -----------------------------
  const carregarCarroReserva = async (filtro = filtroPendentePadrao, automatico = false) => {
    setCarroReservaFiltro(filtro);

    const resultado = await pesquisarPendente(filtro, { tipos: TIPOS_CARRO_RESERVA }, automatico);
    setCarroReservaFiltro(resultado.faixa);
    registrarFaixasDesabilitadas('carroReserva', resultado.faixasVazias);

    const lista = Array.isArray(resultado.dados) ? resultado.dados : [];

    const filtrados = lista
      .map(Preenchendo_Cards)
      .sort((a, b) => (b.diasEvento ?? 0) - (a.diasEvento ?? 0));
    setEventos((prev) => ({ ...prev, carroReserva: filtrados }));
    setEventosBrutos((prev) => ({ ...prev, carroReserva: lista }));
  };

  // ----------------------------------
  const carregarPorColuna = {
    concluido: carregarConcluido,
    assistencia: () => carregarAssistencia(assistenciaFiltro),
    perifericos: () => carregarPerifericos(perifericosFiltro),
    colisao: () => carregarColisao(colisaoFiltro),
    rouboPT: () => carregarRouboPP(rouboPTFiltro),
    carroReserva: () => carregarCarroReserva(carroReservaFiltro),
  };

  const atualizarTodasColunas = () => Promise.all([
    carregarConcluido(),
    carregarAssistencia(assistenciaFiltro),
    carregarPerifericos(perifericosFiltro),
    carregarColisao(colisaoFiltro),
    carregarRouboPP(rouboPTFiltro),
    carregarCarroReserva(carroReservaFiltro),
  ]);

  // --------------------
  const aplicarPagamentoLocal = (atualizacao) => {
    if (!atualizacao?.idEvento || !colunaPagamento) return;

    setEventos((prev) => ({
      ...prev,
      [colunaPagamento]: (prev[colunaPagamento] || []).map((item) => (
        String(item.id) === String(atualizacao.idEvento)
          ? { ...item, status: atualizacao.status, pendente: atualizacao.pendente }
          : item
      )),
    }));
  };

  const atualizarColunaPagamento = async () => {
    const loader = carregarPorColuna[colunaPagamento];
    await (loader ? loader() : atualizarTodasColunas());

    if (pagamentoConfirmadoRef.current) {
      aplicarPagamentoLocal(pagamentoConfirmadoRef.current);
      pagamentoConfirmadoRef.current = null;
    }
  };

  // --------------------
  const salvarPagamento = async (valor, descricao) => {
    const salvo = await BaixarEvento(null, valor, descricao);
    if (!salvo) return salvo;

    const pagamentosAtuais = Array.isArray(listaPesquisa.listaPagamentos)
      ? listaPesquisa.listaPagamentos
      : [];

    const totalPagoAntes = pagamentosAtuais.length > 0
      ? pagamentosAtuais.reduce(
        (total, pagamento) => total + Number(pagamento?.valor ?? pagamento?.valorPG ?? 0), 0) : Number(evento?.valorPag || 0);

    const pendente = Math.max(Number(evento?.orcamento || 0) - totalPagoAntes - Number(valor || 0), 0);

    const idEvento = evento?._id || evento?.id_Evento || evento?.codEvento;

    pagamentoConfirmadoRef.current = {
      idEvento,
      status: pendente > 0 ? 'Liberado' : 'Pago',
      pendente,
    };
    aplicarPagamentoLocal(pagamentoConfirmadoRef.current);

    return salvo;
  };
  // --------------------

  useEffect(() => {
    let ativo = true;
    let timerPiscar;

    const carregarTodos = async () => {
      await Promise.all([
        carregarConcluido(),
        carregarAssistencia(filtroPendentePadrao, true),
        carregarPerifericos(filtroPendentePadrao, true),
        carregarColisao(filtroPendentePadrao, true),
        carregarRouboPP(filtroPendentePadrao, true),
        carregarCarroReserva(filtroPendentePadrao, true),
      ]);
      // Piscar só começa 3s após todos os eventos carregarem
      timerPiscar = setTimeout(() => setPiscarLiberado(true), 2000);
    };

    if (ativo) {
      carregarTodos();
    }

    return () => {
      ativo = false;
      clearTimeout(timerPiscar);
    };
  }, []);
  // ---------------------------------

  const abrirModalPagamento = async (eventoResumo, columnKey) => {
    if (!eventoResumo?.id) return;
    await PesqIdEvento(eventoResumo.id);
    setColunaPagamento(columnKey);
    setModalPagAberto(true);
  };

  const fecharModalPagamento = () => setModalPagAberto(false);

  // --------------------
  const abrirTarefasEvento = (eventoResumo, columnKey) => {
    const eventoOriginal = eventosBrutos[columnKey]?.find((item) => (
      (item?._id || item?.id_Evento || item?.codEvento) === eventoResumo.id
    ));

    setEventoTarefaInicial(eventoOriginal || { ...eventoResumo, _id: eventoResumo.id });
    setNotasAbertas(true);
  };

  const abrirBlocoDeNotas = () => {
    setEventoTarefaInicial(null);
    setNotasAbertas(true);
  };

  const fecharBlocoDeNotas = () => {
    setNotasAbertas(false);
    setEventoTarefaInicial(null);
  };

  const colunas = useMemo(() => (
    [
      <EventColumn 
        key="concluido" 
        columnKey="concluido"
        title="Concluído" 
        events={eventos.concluido} 
        accent="#00b109" 
        onCardClick={abrirModalPagamento}
        onTasksClick={abrirTarefasEvento}
      />,
      <EventColumn
        key="assistencia"
        columnKey="assistencia"
        title="Assistencia 24h"
        events={eventos.assistencia}
        accent="#ff40c6"
        filters={filtrosPendente.map((item) => ({
          ...item,
          active: item.key === assistenciaFiltro,
        }))}
        disabledFilters={faixasDesabilitadas.assistencia}
        onFilterClick={(filtro) => carregarAssistencia(filtro)}
        onCardClick={abrirModalPagamento}
        onTasksClick={abrirTarefasEvento}
      />,
      <EventColumn
        key="perifericos"
        columnKey="perifericos"
        title="Periféricos"
        events={eventos.perifericos}
        accent="#8b5cf6"
        filters={filtrosPendente.map((item) => ({
          ...item,
          active: item.key === perifericosFiltro,
        }))}
        disabledFilters={faixasDesabilitadas.perifericos}
        onFilterClick={(filtro) => carregarPerifericos(filtro)}
        onCardClick={abrirModalPagamento}
        onTasksClick={abrirTarefasEvento}
      />,
      <EventColumn
        key="carroReserva"
        columnKey="carroReserva"
        title="Carro Reserva"
        events={eventos.carroReserva}
        accent="#3255f1"
        filters={filtrosPendente.map((item) => ({
          ...item,
          active: item.key === carroReservaFiltro,
        }))}
        disabledFilters={faixasDesabilitadas.carroReserva}
        onFilterClick={(filtro) => carregarCarroReserva(filtro)}
        onCardClick={abrirModalPagamento}
        onTasksClick={abrirTarefasEvento}
      />,
      <EventColumn
        key="colisao"
        columnKey="colisao"
        title="Colisão"
        events={eventos.colisao}
        accent="#f59e0b"
        filters={filtrosPendente.map((item) => ({
          ...item, active: item.key === colisaoFiltro,
        }))}
        disabledFilters={faixasDesabilitadas.colisao}
        onFilterClick={(filtro) => carregarColisao(filtro)}
        onCardClick={abrirModalPagamento}
        onTasksClick={abrirTarefasEvento}
      />,
      <EventColumn
        key="rouboPT"
        columnKey="rouboPT"
        title="Roubo/PT/Financ."
        events={eventos.rouboPT}
        accent="#ef4444"
        filters={filtrosPendente.map((item) => ({
          ...item,
          active: item.key === rouboPTFiltro,
        }))}
        disabledFilters={faixasDesabilitadas.rouboPT}
        onFilterClick={(filtro) => carregarRouboPP(filtro)}
        onCardClick={abrirModalPagamento}
        onTasksClick={abrirTarefasEvento}
      />,
      
    ]
  ), [eventos, eventosBrutos, assistenciaFiltro, perifericosFiltro, colisaoFiltro, rouboPTFiltro, carroReservaFiltro, faixasDesabilitadas]);

  // Sequência global de piscadas: do mais atrasado ao menos atrasado entre todas as colunas
  // Cada card mantém o mesmo "slot" e o mesmo ciclo enquanto permanecer na tela,
  // para que trocar um filtro não reinicie a animação dos demais.
  const piscadaRef = useRef({ inicio: null, slots: new Map(), ciclo: 0 });
  const blinkDelays = useMemo(() => {
    if (!piscarLiberado) return new Map();
    const estado = piscadaRef.current;
    if (estado.inicio === null) estado.inicio = Date.now();

    const ordem = Object.values(eventos)
      .flat()
      .filter(isEventoAtrasado)
      .sort((a, b) => getDiasAtraso(b) - getDiasAtraso(a));
    const chaveDe = (event) => event.id || event.codigo || event.nome;

    // Libera slots de cards que saíram e atribui o menor slot livre aos novos
    const chavesAtuais = new Set(ordem.map(chaveDe));
    estado.slots.forEach((_, chave) => {
      if (!chavesAtuais.has(chave)) estado.slots.delete(chave);
    });
    const usados = new Set([...estado.slots.values()].map((entrada) => entrada.slot));
    ordem.forEach((event) => {
      const chave = chaveDe(event);
      if (estado.slots.has(chave)) return;
      let slot = 0;
      while (usados.has(slot)) slot += 1;
      usados.add(slot);
      estado.slots.set(chave, { slot });
    });

    // Ciclo = sequência completa + pausa; só cresce para não reiniciar quem já pisca
    const cicloNecessario = (Math.max(-1, ...usados) + 1) * PASSO_PISCADA + DURACAO_PISCADA + PAUSA_PISCADA;
    estado.ciclo = Math.max(estado.ciclo, cicloNecessario);

    // Atraso negativo alinha cards novos à fase do ciclo global; fixado na entrada do card
    const fase = ((Date.now() - estado.inicio) / 1000) % estado.ciclo;
    return new Map(ordem.map((event) => {
      const entrada = estado.slots.get(chaveDe(event));
      if (entrada.atraso === undefined) {
        entrada.atraso = Number((entrada.slot * PASSO_PISCADA - fase).toFixed(1));
      }
      return [event, { atraso: entrada.atraso, ciclo: estado.ciclo }];
    }));
  }, [eventos, piscarLiberado]);

  // ##########################################

  const Raiz = temaEscuro ? S.TemaEscuro : S.Page;

  return (
    <Raiz>
      <Header />

      <S.Content>
        <S.Header>
          <div style={{display:"flex", alignItems:"center", gap:"10px"}}>
            <S.BotaoVoltar type="button" onClick={voltar}>
              <FiArrowLeft size={18} />
              Voltar
            </S.BotaoVoltar>
            <S.Title>Eventos Em Aberto/Vencidos</S.Title>
            <S.BotaoNotas type="button" onClick={abrirBlocoDeNotas} aria-label="Abrir bloco de notas" title="Bloco de notas">
              <FiClipboard size={21} />
            </S.BotaoNotas>
          </div>
          <S.BotaoTema
            type="button"
            onClick={alternarTema}
            aria-label={temaEscuro ? 'Ativar modo claro' : 'Ativar modo escuro'}
            title={temaEscuro ? 'Modo claro' : 'Modo escuro'}
          >
            {temaEscuro ? <FiSun size={21} /> : <FiMoon size={21} />}
          </S.BotaoTema>
        </S.Header>

        <S.Board>{colunas.map((coluna) => cloneElement(coluna, { blinkDelays }))}</S.Board>
      </S.Content>

      {notasAbertas && (
        <TarefasDia
          aberto={notasAbertas}
          onFechar={fecharBlocoDeNotas}
          eventosBrutos={eventosBrutos}
          eventoInicial={eventoTarefaInicial}
        />
      )}

      <PagEventoModal
        aberto={modalPagAberto}
        onFechar={fecharModalPagamento}
        evento={evento}
        nomeUserCadastro={(() => {
          const origem = listaPesquisa.listaEvento?.[0]?.userCadastro
            ?? Object.values(eventosBrutos || {}).flat().find((item) => (item?._id || item?.id_Evento || item?.codEvento) === evento?.id_Evento)?.userCadastro;
          return origem?.nome || '';
        })()}
        pagamentos={listaPesquisa.listaPagamentos}
        temArquivosNovos={listaPesquisa.listaArquivos.length > 0}
        anexos={<AddArquivos permitirExcluirArquivosSalvos={false} apenasArquivosPagamento />}
        aoAlterarEvento={SetEvento}
        aoSelecionarArquivo={SelectFile}
        aoSalvarPagamento={salvarPagamento}
        aoPagamentoConfirmado={atualizarColunaPagamento}
      />

      <Footer />
    </Raiz>
  );
}
